export default {"src":"/_next/static/media/awa-logo.443d3cd5.svg","height":51,"width":248,"blurWidth":0,"blurHeight":0};